import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  DataTable,
  Field,
  CurrencyField,
  DateTimeField,
  PaymentsDataField,
  BilledField,
  ContractEONType,
  ContractTypeBadgeField,
} from '../../../../commons/DataTable';
import CustomCheckbox from '../../../../commons/Checkboxes/CustomCheckboxes';
import { useAuth } from '../../../../commons/Auth';
import IAFCustomCheckboxes from '../../../../commons/Checkboxes/IAFCustomCheckboxes';
import AdminStateEnergyField from '../../../../commons/DataTable/AdminStateEnergyField';
import FieldIafNumber from '../../../../commons/DataTable/FieldIafNumber';

function EnergyRoyaltyTable({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  truncateTable,
  showEmptyTableMessage,
  allowedRoles = [],
  onSelectChange,
  profile = {},
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin }] = useAuth();
  const { offset, limit } = query;
  if (newIsAdmin === undefined) return null;

  const onCheck = (report) => {
    if (!allowedRoles.includes('superadmin')) {
      return;
    }
    onSelectChange(report);
  };

  return newIsAdmin ? (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      {!truncateTable && (
        <IAFCustomCheckboxes
          onSelectChange={onCheck}
          onClick={(e) => e.stopPropagation()}
          visible={newIsAdmin && profile.type !== 'UTILIZER'}
          profile={profile}
        />
      )}

      {!truncateTable && (
        <Field title="Nome Cliente" source="condo_name" className="text-left" />
      )}
      {!truncateTable && (
        <Field title="Partita IVA Cliente" source="condo_vat_cf" />
      )}
      <Field
        title="Referente ufficio"
        source="customerInfo.office.contactPerson"
        visible={!truncateTable && profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ragione sociale ufficio"
        source="customerInfo.office.businessName"
        visible={!truncateTable && profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ufficio"
        source="customerInfo.office.office"
        visible={!truncateTable && profile.type === 'ASSOCIATION'}
      />
      {!truncateTable && (
        <ContractEONType title="Nome prodotto" source="product_name" />
      )}
      {!truncateTable && (
        <ContractTypeBadgeField title="Voce" source="partnerEonType" />
      )}
      {!truncateTable && <Field title="POD/PDR" source="pod_pdr" />}
      {!truncateTable && (
        <Field
          title="Consumo da contratto iniziale"
          source="initial_contractual_consumption"
          hideForStorno
        />
      )}
      {!truncateTable && (
        <Field
          title="Consumo da contratto"
          source="contractual_consumption"
          hideForStorno
        />
      )}
      {!truncateTable && (
        <Field
          title="Consumo attuale"
          source="actual_consumption"
          hideForStorno
        />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Data creazione"
          source="contract_signing_date"
          format="DD/MM/YYYY"
        />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Data attivazione"
          source="activation_start_date"
          format="DD/MM/YYYY"
        />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Data Scadenza"
          source="contract_end_date"
          format="DD/MM/YYYY"
          hideForStorno
        />
      )}
      <CurrencyField
        title="Imponibile"
        source="contract_value"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto Extra"
        source="extraShare"
        class="txt-table-right"
        visible={newIsAdmin}
      />
      <CurrencyField
        title="Quota responsabile"
        source="adminShare"
        className="txt-table-right"
        visible={profile.type !== 'UTILIZER'}
      />
      <CurrencyField
        title="Quota responsabile maturata"
        source="earnedAdminShare"
        className="txt-table-right"
        visible={profile.type !== 'UTILIZER'}
      />
      <CurrencyField
        title="Diritto a Fatturare"
        source="billableAdminShare"
        className="txt-table-right"
        visible={profile.type !== 'UTILIZER'}
      />
      <BilledField
        title="Invitato a Fatturare"
        className="txt-table-right"
        visible={!truncateTable && newIsAdmin && profile.type !== 'UTILIZER'}
      />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iafs.0.number"
        visible={!truncateTable && newIsAdmin && profile.type !== 'UTILIZER'}
      />
    </DataTable>
  ) : (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      {!truncateTable && (
        <Field title="Nome Cliente" source="condo_name" className="text-left" />
      )}
      {!truncateTable && (
        <Field title="Partita IVA Cliente" source="condo_vat_cf" />
      )}
      <Field
        title="Referente ufficio"
        source="customerInfo.office.contactPerson"
        visible={!truncateTable && profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ragione sociale ufficio"
        source="customerInfo.office.businessName"
        visible={!truncateTable && profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ufficio"
        source="customerInfo.office.office"
        visible={!truncateTable && profile.type === 'ASSOCIATION'}
      />
      {!truncateTable && (
        <ContractEONType title="Nome prodotto" source="product_name" />
      )}
      {!truncateTable && (
        <ContractTypeBadgeField title="Voce" source="partnerEonType" />
      )}
      {!truncateTable && <Field title="POD/PDR" source="pod_pdr" />}
      {!truncateTable && (
        <Field
          title="Consumo da contratto iniziale"
          source="initial_contractual_consumption"
          hideForStorno
        />
      )}
      {!truncateTable && (
        <Field
          title="Consumo da contratto"
          source="contractual_consumption"
          hideForStorno
        />
      )}
      {!truncateTable && (
        <Field
          title="Consumo attuale"
          source="actual_consumption"
          hideForStorno
        />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Data creazione"
          source="contract_signing_date"
          format="DD/MM/YYYY"
        />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Data attivazione"
          source="activation_start_date"
          format="DD/MM/YYYY"
        />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Data Scadenza"
          source="contract_end_date"
          format="DD/MM/YYYY"
          hideForStorno
        />
      )}
      <CurrencyField
        title="Quota responsabile"
        source="adminShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota responsabile maturata"
        source="earnedAdminShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Diritto a Fatturare"
        source="billableAdminShare"
        className="txt-table-right"
      />
    </DataTable>
  );
}

export default withRouter(EnergyRoyaltyTable);
